export const siteSettings = {
  name: "100x Markets",
  link: "https://spacexchange.online",
  email: "support@spacexchange.online",
  appLink: "https://app.spacexchange.online",
};
